export default {
  me: {
    default: 'me',
    redemption: 'me/coupons',
    subscriptions: 'me/subscriptions',
    introEligibility: 'me/intro-eligibility',
    communicationPreferences: 'me/opt-ins',
    profile: {
      base: 'me/profile/base',
      email: 'me/profile/email',
      password: 'me/profile/password'
    }
  },
  planCheckout: 'checkout',
  subscriptionPortal: 'chargebee/portal',
  products: 'chargebee/products',
  planCurrency: 'chargebee/currency-code'
};



// WEBPACK FOOTER //
// ./src/api/endpoints.js